import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=3546f39c&scoped=true"
import script from "./AppDetail.vue?vue&type=script&lang=js"
export * from "./AppDetail.vue?vue&type=script&lang=js"
import style0 from "./AppDetail.vue?vue&type=style&index=0&id=3546f39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3546f39c",
  null
  
)

export default component.exports